import { type Service, type UserBusinessPartner } from '@sr/types';
import { findCountryFromDwKey, isConfidential } from '../country';

export const isRecycling = (dwKey: string) =>
  !isConfidential(dwKey) && !!findCountryFromDwKey(dwKey);

/**
 * Extracts the business partner ID from a key and returns the services
 * from the matching permission.
 *
 * key format: companyId_partnerId_source-location (e.g., 104_03839115_EDW-03839115)
 * permission.id format: companyId_partnerId (e.g., 104_03839115)
 */
export const getServicesFromPermissionsByKey = (
  key: string,
  permissions: UserBusinessPartner[],
): Service[] | undefined => permissions.find((p) => p.id === key)?.services;
